module.exports = __webpack_public_path__ + "img/calidad.1ac0fd53.png";